// extracted by mini-css-extract-plugin
module.exports = {"searchMenu":"TU","itemCount":"UU","filters":"VU"};